import { spacing } from '@moderneinc/design-system-tokens';
import { Box, Stack, Typography } from '@mui/material';
import { useSession } from 'next-auth/react';
import { type FunctionComponent, useCallback } from 'react';

import { sanitizeDisplayName } from '../../helpers/string.helper';
import { ScmConnections } from '../scm-connection-status/scm-connection-status.component';

export const UserCard: FunctionComponent = () => {
  const { data: session } = useSession();

  const isUserNameUnique = useCallback(() => {
    if (
      session?.user?.email &&
      session?.user?.userName &&
      session?.user?.fullName
    ) {
      const sameAsEmail =
        session.user.email.trim().toLocaleLowerCase() ===
        session.user.userName.trim().toLocaleLowerCase();

      const sameAsFullName =
        session.user.fullName.trim().toLocaleLowerCase() ===
        session.user.userName.trim().toLocaleLowerCase();

      return !(sameAsEmail || sameAsFullName);
    }
  }, [session]);

  return (
    <Box
      sx={{
        marginTop: `${spacing.spacing_1}px`,
        marginLeft: `${spacing.spacing_2}px`,
        marginRight: `${spacing.spacing_2}px`,
        marginBottom: `${spacing.spacing_1}px`
      }}
    >
      <Stack sx={{ gap: `${spacing.spacing_2}px` }}>
        <Typography
          variant="body"
          sx={{
            fontWeight: '600',
            lineHeight: 1
          }}
        >
          {sanitizeDisplayName(session.user.fullName)}
        </Typography>
        <ScmConnections />
        <Stack sx={{ gap: 0.25 }}>
          <Typography
            variant="caption"
            sx={{
              whiteSpace: 'nowrap',
              lineHeight: 1.1,
              color: (theme) => theme.palette.grey[600],
              fontFamily: (theme) => theme.typography.fontFamilyMonospace
            }}
          >
            {session.user.email}
          </Typography>
          {isUserNameUnique() && (
            <Typography
              variant="caption"
              sx={{
                whiteSpace: 'nowrap',
                lineHeight: 1.1,
                color: (theme) => theme.palette.grey[600]
              }}
            >
              {sanitizeDisplayName(session.user.userName)}
            </Typography>
          )}
        </Stack>
      </Stack>
    </Box>
  );
};
